// src/components/VitalBoxes.jsx
import React from 'react';
import { Heart, Wind, Activity, Droplets, Thermometer, AlertCircle } from 'lucide-react';

const vitalConfig = [
    { key: 'ews', icon: AlertCircle, label: 'EWS', unit: 'Count' },
    { key: 'hr', icon: Heart, label: 'HR', unit: 'BPM' },
    { key: 'resp_rate', icon: Wind, label: 'RR', unit: 'RPM' },
    { key: 'nibp_systolic', icon: Activity, label: 'BP(Sys)', unit: 'mmHg' },
    { key: 'nibp_diastolic', icon: Activity, label: 'BP(Dia)', unit: 'mmHg' },
    { key: 'spo2', icon: Droplets, label: 'SpO₂', unit: '%' },
    { key: 'temp', icon: Thermometer, label: 'Temp', unit: '°C' },
];

const vitalRanges = {
    ews: { normal: [0, 3], moderate: [4, 6] },
    hr: { normal: [60, 100], moderate: [50, 120] },
    resp_rate: { normal: [12, 20], moderate: [9, 24] },
    nibp_systolic: { normal: [90, 120], moderate: [70, 139] },
    nibp_diastolic: { normal: [60, 80], moderate: [50, 89] },
    spo2: { normal: [95, 100], moderate: [90, 100] },
    temp: { normal: [36.1, 37.5], moderate: [35.5, 38.0] },
};

const getRiskLevel = (value, key) => {
    const r = vitalRanges[key];
    if (!r) return 'normal';
    if (value >= r.normal[0] && value <= r.normal[1]) return 'normal';
    if (value >= r.moderate[0] && value <= r.moderate[1]) return 'moderate';
    return 'high';
};

const getRiskClass = (level) => {
    switch (level) {
        case 'normal': return 'text-green-600 bg-green-50 border-green-200';
        case 'moderate': return 'text-yellow-600 bg-yellow-50 border-yellow-200';
        case 'high': return 'text-red-600 bg-red-50 border-red-200';
        default: return 'text-gray-600 bg-gray-50 border-gray-200';
    }
};

const formatValue = (key, v) => (key === 'temp' ? (v ?? 0).toFixed(1) : Math.round(v ?? 0));

export default function VitalBoxes({ vitals }) {
    return (
        <div className="grid grid-cols-7 gap-2 mb-4">
            {vitalConfig.map(({ key, icon: Icon, label, unit }) => {
                const value = vitals[key] ?? 0;
                const risk = getRiskLevel(value, key);
                const cls = getRiskClass(risk);

                return (
                    <div
                        key={key}
                        className={`flex flex-col items-center justify-center p-2 border rounded-lg ${cls}`}
                    >
                        <Icon className="h-5 w-5 mb-1" />
                        <span className="text-xs font-medium">{label}</span>
                        <span className="text-xl font-bold">{formatValue(key, value)} <span className="text-xs font-normal text-gray-600">{unit}</span></span>

                    </div>
                );
            })}
        </div>
    );
}